import request from './common/request'
import { MERCHANT_COZE_URI } from './urls'

/**
 * 解析后端返回的 Coze accessToken
 * @param {*} result request 拦截器返回的 res.data
 * @returns {string}
 */
export function normalizeAccessToken (result) {
  if (!result) return ''
  if (typeof result === 'string') return result.trim()
  return (
    result.accessToken ||
    result.access_token ||
    result.token ||
    ''
  )
}

/**
 * 获取 Coze 智能体 accessToken
 * GET /merchant/simbart/coze/accessToken
 * Header: Authorization: Bearer {商户JWT}
 * @returns {Promise<string>}
 */
export async function getAccessToken () {
  const result = await request({
    url: `${MERCHANT_COZE_URI}/accessToken`,
    method: 'GET'
  })
  const token = normalizeAccessToken(result)
  if (!token) {
    throw new Error('Coze accessToken 为空')
  }
  return token
}



// WEBPACK FOOTER //
// ./src/api/merchant-coze.js